module.exports = __webpack_public_path__ + "static/media/logo_vertical.ffecf6bd.png";